import "./styles.css";
import { ReactComponent as Filter } from "../../assets/filter.svg";
import { ReactComponent as Close } from "../../assets/close-cross.svg";
import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { deepCopy, isEmptyList } from "../../utils";
import Checkbox from "../Checkbox";

function ButtonFilter(props) {
  const { buttonLabel, filterOptions, selectedOptions, onChange, disabled } =
    props;
  const { t } = useTranslation();
  const componentRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);

  function handleClear() {
    onChange([]);
  }

  function handleFilterChange(value) {
    const updatedValues = deepCopy(selectedOptions);
    if (updatedValues.includes(value)) {
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      updatedValues.push(value);
    }
    onChange(updatedValues);
  }
  useEffect(() => {
    const handleClick = (e) => {
      if (componentRef.current && !componentRef.current.contains(e.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [componentRef]);

  const isFiltered = !isEmptyList(selectedOptions);

  return (
    <div className="button-filter" ref={componentRef}>
      <div className="button-filter-actions">
        <div className="button-filter-container">
          <button
            onClick={() => {
              setShowMenu((prev) => !prev);
            }}
            disabled={disabled}
            className={isFiltered ? "primary" : "secondary"}
          >
            {!isFiltered && <Filter />}
            {isFiltered && (
              <Close
                onClick={() => {
                  handleClear(null);
                }}
              />
            )}
            <span>{t(buttonLabel)}</span>
          </button>
          {showMenu && (
            <div className="button-filter-menu-container">
              <div className="button-filter-menu fadeIn">
                <div>
                  <div className="button-filter-menu-content">
                    {!isEmptyList(filterOptions) &&
                      filterOptions.map((filterOption) => (
                        <div
                          key={filterOption.uuid}
                          className={`button-filter-menu-option${
                            selectedOptions.includes(filterOption.uuid)
                              ? " selected"
                              : ""
                          }`}
                        >
                          <div>
                            <Checkbox
                              changeHandler={(value) => {
                                handleFilterChange(value);
                              }}
                              isChecked={selectedOptions.includes(
                                filterOption.uuid
                              )}
                              value={filterOption.uuid}
                              display={filterOption.name}
                            />
                          </div>
                          <div
                            onClick={() => {
                              handleFilterChange(filterOption.uuid);
                            }}
                          >
                            {filterOption.name}
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ButtonFilter;
